export default __webpack_public_path__ + "static/media/casaduana_objetivo02.2c2b179b.jpg";